import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useFolderCardStyles = makeStyles({
  folderCardListItem: {
    marginRight: '16px',
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    width: '194px',
    height: '220px',
    boxSizing: 'border-box',
    ...shorthands.overflow('hidden'),
    pointerEvents: 'auto',
  },
  cardPreview: {
    width: '194px',
    height: '160px',
    objectFit: 'cover',
    ...shorthands.overflow('hidden'),
  },
  footer: {
    width: '194px',
    ...shorthands.overflow('hidden'),
    marginLeft: '-15px',
    marginBottom: '-15px',
    paddingLeft: '15px',
  },
  footerContent: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: '0px',
    ...shorthands.gap('4px'),
  },
  iconAndName: {
    display: 'flex',
    alignItems: 'center',
  },
  folderName: {
    width: '142px',
    ...shorthands.overflow('hidden'),
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  caption: {
    paddingLeft: '2px',
  },
  imageGrid: {
    display: 'grid',
    width: '100%',
    height: '100%',
    justifyItems: 'center',
    backgroundColor: tokens.colorNeutralBackground3,
  },
  thumbnailImage: {
    objectFit: 'cover',
    width: '100%',
    height: '100%',
  },
  oneImage: {
    display: 'block',
    width: '100%',
    height: '160px', // Full height of preview section
    objectFit: 'cover',
  },
  twoImages: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)', // 2 equal-width columns
    width: '100%',
    height: '160px', // Full height of preview section
  },
  threeImages: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridTemplateRows: '80px 80px', // Use pixel values but fractions
    height: '160px', // Full height of preview section

    '& > :nth-child(1)': {
      ...shorthands.gridArea(1, 1, 2, 1), // First image takes full height of first column
      height: '160px',
    },
    '& > :nth-child(2)': {
      ...shorthands.gridArea(1, 2, 1, 2), // Second image is top in second column
      height: '80px',
    },
    '& > :nth-child(3)': {
      ...shorthands.gridArea(2, 2, 2, 2), // Third image is bottom in second column
      height: '80px',
    },
  },
  fourImages: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)', // 2 equal columns
    gridTemplateRows: 'repeat(2, 1fr)', // 2 equal rows
    width: '100%',
    height: '160px', // Full height of preview section

    '& img': {
      height: '80px', // Set explicit height for each grid cell
      objectFit: 'cover',
    },
  },
});
